export default __webpack_public_path__ + "static/media/promo-banner-loans.a0c70795.svg";